import Icon from '../components/Icon.vue'

Icon.register({"volume-off":{"width":256,"height":512,"paths":[{"d":"M256 88V424C256 445.4 230.1 456 215 441L126.1 352H24C10.7 352 0 341.3 0 328V184C0 170.7 10.7 160 24 160H126.1L215 71C230 56 256 66.6 256 88z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/volume-off.js
// module id = null
// module chunks = 